import React, { useEffect, useState } from "react";
import Navbar from "../component/navbar";
import { ZegoUIKitPrebuilt } from "@zegocloud/zego-uikit-prebuilt";
import { useParams, useSearchParams } from "react-router-dom";
import "./css/meeting.css";
import { Alert, AutoComplete, Image, message, Skeleton, Select } from "antd";
import ReactPlayer from "react-player";
import axios from "axios";
import MeetingSkeleton from "../component/skeleton";
import * as countryCodes from "country-codes-list";

// Shared styles for all React Select components
const customSelectStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: "#dcf0ff",
    border: "none",
    borderRadius: "10px",
    padding: "0px 8px",
    minHeight: "44px",
    fontSize: "14px",
    boxShadow: "none",
    ":hover": {
      border: "none",
      boxShadow: "none",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 0",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    paddingRight: "8px",
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: "#f5f8ff",
    borderRadius: "8px",
    border: "none",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  }),
  option: (base, state) => ({
    ...base,
    borderRadius: "6px",
    padding: "10px 12px",
    fontSize: "14px",
    backgroundColor: state.isSelected
      ? "#19b5ff"
      : state.isFocused
        ? "#e0f4ff"
        : "white",
    cursor: "pointer",
    margin: "2px 4px",
  }),
};

function Meeting() {
  const { id } = useParams();
  const [meeting, setmeeting] = useState();
  const [user, setuser] = useState([]);
  const [entermeeting, setentermeeting] = useState(false);
  const [chatbox, setchatbox] = useState(false);
  const [date, setdate] = useState([]);
  const [registerform, setregisterform] = useState(true);
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [open, setOpen] = useState(false);
  const [content, setcontent] = useState("");
  const [messagesss, setmessagesss] = useState([]);
  const [inputquestin, setinputquestin] = useState("");
  const [countries, setCountries] = useState([]);
  const [searchParams] = useSearchParams();
  const namee = searchParams.get("name");
  const emaill = searchParams.get("email");
  const login = searchParams.get("login");

  const dateString = meeting?.Schedule;
  const targetDate = new Date(dateString).getTime(); // Convert the date string to a timestamp

  const [timeRemaining, setTimeRemaining] = useState();

  useEffect(() => {
    if (!meeting?.Schedule) return;

    calculateTimeRemaining();

    const timer = setInterval(() => {
      calculateTimeRemaining();
    }, 1000);

    return () => clearInterval(timer);
  }, [meeting?.Schedule]);

  //     function calculateTimeRemaining() {
  //       // const now = new Date().getTime();  // Current time in milliseconds
  //       const now = new Date(); // Get the current date and time
  //       const utcOffset = now.getTimezoneOffset() * 60000; // Get the timezone offset in milliseconds
  //       // const londonOffset = 60; // London is UTC+1 during BST  for summer =============================== (04 hour of difference)
  //       const londonOffset = 0; // London is UTC+1 during BST   for winter =============================== (05 hour of difference)
  //       const ukNow = new Date(
  //         now.getTime() + utcOffset + londonOffset * 60000,
  //       ).getTime(); // Adjust to UK time

  //       const difference = targetDate - ukNow; // Time difference in milliseconds

  //       if (difference <= 0) {
  //         return { days: 0, hours: 0, minutes: 0, seconds: 0 }; // If the time is up, return zero values
  //       }

  //       const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  //       const hours = Math.floor(
  //         (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
  //       );
  //       const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  //       const seconds = Math.floor((difference % (1000 * 60)) / 1000);
  // setTimeRemaining({ days, hours, minutes, seconds })
  //       return { days, hours, minutes, seconds };
  //     }
  function calculateTimeRemaining() {
    if (!meeting?.Schedule) {
      setTimeRemaining({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      return;
    }

    const targetDate = new Date(meeting.Schedule).getTime();

    if (isNaN(targetDate)) {
      setTimeRemaining({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      return;
    }

    const now = new Date();
    const utcOffset = now.getTimezoneOffset() * 60000;
    const londonOffset = 60; //0 for 5 hours gap between UK and pk
        
    const ukNow = new Date(
      now.getTime() + utcOffset + londonOffset * 60000,
    ).getTime();

    const difference = targetDate - ukNow;

    if (difference <= 0) {
      setTimeRemaining({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      return;
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    setTimeRemaining({ days, hours, minutes, seconds });
  }

  const [options, setOptions] = useState([
    {
      value: "United Kingdom",
    },
    {
      value: "Ireland",
    },
  ]);
  const [phoneCountryCode, setPhoneCountryCode] = useState("");
  const [phoneCountries, setPhoneCountries] = useState([]);
  const [phoneCountryCodeByIso, setPhoneCountryCodeByIso] = useState({});
  const MAX_PHONE_DIGITS = 15;
  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  useEffect(() => {
    if (login === "true") {
      setname(namee);
      setemail(emaill);

      // let user
      // if (meeting.length > 0) {

      //     const user = meeting.user.find(user =>
      //         user.Email?.toLowerCase() === emaill?.toLowerCase()
      //     );
      // }
      // if (user) {
      //     // alert("login")
      //     setentermeeting(true)
      // } else {
      // alert("nhi")
      setentermeeting(true);
      // }
    }

    const date = new Date(meeting?.Schedule);

    const day = date.getDate(); // 09
    const month = date.getMonth() + 1; // 09 (Note: months are zero-indexed, so add 1)
    const year = date.getFullYear(); // 2024
    let hours = date.getHours(); // 13
    const minutes = date.getMinutes();

    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Determine AM/PM
    const period = hours >= 12 ? "PM" : "AM";

    // Convert to 12-hour format
    hours = hours % 12 || 12; // If hour is 0 (midnight), convert to 12

    // Format minutes to always have two digits
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;

    setdate({
      day: day,
      month: monthNames[month - 1], // Get the month name from the array
      year: year, // 2024
      hours: hours, // Converted to 12-hour format
      minutes: formattedMinutes, // Format minutes to 2 digits
      period: period, // AM or PM
    });
  }, [meeting]);
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(
          "https://restcountries.com/v3.1/all?fields=name",
        );
        // Sort countries alphabetically by name
        const sortedCountries = response.data.sort((a, b) =>
          a.name.common.localeCompare(b.name.common),
        );
        setCountries(sortedCountries);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();

    // Get country calling codes for phone input
    const myCountryCodesObject = countryCodes.customList(
      "countryNameEn",
      "+{countryCallingCode}",
    );
    const phoneCountryList = Object.entries(myCountryCodesObject)
      .map(([name, code]) => ({
        name,
        code,
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
    setPhoneCountries(phoneCountryList);

    const countryCodeMap = countryCodes.customList(
      "countryCode",
      "+{countryCallingCode}",
    );
    setPhoneCountryCodeByIso(countryCodeMap);
  }, []);

  useEffect(() => {
    const fetchIpCountry = async () => {
      if (phoneCountryCode) {
        return;
      }

      try {
        const response = await axios.get("https://geolocation-db.com/json/");
        const isoCode = response?.data?.country_code;
        if (!isoCode) {
          return;
        }

        const callingCode = phoneCountryCodeByIso[isoCode.toUpperCase()];
        if (callingCode) {
          setPhoneCountryCode(callingCode);
        }
      } catch (error) {
        console.error("Error fetching IP country:", error);
      }
    };

    if (Object.keys(phoneCountryCodeByIso).length > 0) {
      fetchIpCountry();
    }
  }, [phoneCountryCode, phoneCountryCodeByIso]);
  // console.log("========>", meeting);
  useEffect(() => {
    if (!phoneCountryCode || !meeting?.Fields) {
      return;
    }

    const phoneField = meeting.Fields.find((f) => f.type === "phone");
    if (!phoneField) {
      return;
    }

    setFormData((prevData) => {
      const currentValue = prevData[phoneField.title] || "";
      if (currentValue.trim()) {
        return prevData;
      }

      return {
        ...prevData,
        [phoneField.title]: `${phoneCountryCode} `,
      };
    });
  }, [phoneCountryCode, meeting]);
  useEffect(() => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    const urlencoded = new URLSearchParams();
    urlencoded.append("URL", id);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_API_URL}/get-event-by-url`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setmeeting(result.data);
        console.log(result?.data?._id)
        onJoinRoom(result?.data?._id);
        setmessagesss(result.data.questions);

        if (result.lessthen10) {
          setregisterform(false);
        }
      })
      .catch((error) => console.log("error", error));
  }, []);
  // const myMeeting = async (element) => {

  //     const kitToken = ZegoUIKitPrebuilt.generateKitTokenForTest(
  //         parseInt("1426619796"),
  //         "224cefed6979db88285a5c524756adf4",
  //         id,//meeting id
  //         email, //for test
  //         name,//for test
  //         // user?.uid ? user.uid : generateMeetingID(),
  //         // user?.displayName ? user.displayName : generateMeetingID()
  //     );
  //     const zp = ZegoUIKitPrebuilt.create(kitToken);

  //     zp?.joinRoom({
  //         container: element,
  //         showPreJoinView: false,
  //         // showScreenSharingButton: true,
  //         // showRemoveUserButton: true,
  //         // showRoomTimer: true,

  //         sharedLinks: [
  //             {
  //                 name: meeting.title,
  //                 url: "academy.yourgutmap.co.uk/" + id,
  //             },
  //         ],
  //         scenario: {
  //             mode: "LiveStreaming",
  //             config: {
  //                 role: "Audience",
  //             }
  //         },

  //     });

  // };

  const onJoinRoom = (meetingid) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    const urlencoded = new URLSearchParams();
    urlencoded.append("_id", meetingid || meeting._id);
    urlencoded.append("email", emaill || email);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_API_URL}/add-joining-time`, requestOptions)
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  };


  const CountdownTimer = ({ timeRemaining }) => {
    return (
      <div className="countdown-container">
        <h1 className="countdown-title">
          Remaining time to <span className="highlight">start the event</span>
        </h1>
        <div className="countdown">
          <div className="countdown-item">
            <div className="countdown-number">{timeRemaining?.days}</div>
            <div className="countdown-label">DAYS</div>
          </div>
          <div className="countdown-item">
            <div className="countdown-number">{timeRemaining?.hours}</div>
            <div className="countdown-label">HOURS</div>
          </div>
          <div className="countdown-item">
            <div className="countdown-number">{timeRemaining?.minutes}</div>
            <div className="countdown-label">MINUTES</div>
          </div>
          <div className="countdown-item">
            <div className="countdown-number">{timeRemaining?.seconds}</div>
            <div className="countdown-label">SECONDS</div>
          </div>
        </div>
      </div>
    );
  };
  const [formData, setFormData] = useState(() => {
    const initialData = {};
    const fields = meeting?.Fields || [];
    fields.forEach((field) => {
      initialData[field.title] = field.type === "checkbox" ? false : "";
    });
    return initialData;
  });
  const handleChange = (title, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [title]: value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailField = meeting?.Fields?.find(
      (f) =>
        f?.type?.toLowerCase() === "email" ||
        f?.title?.toLowerCase().includes("email"),
    );
    const enteredEmail = emailField
      ? (formData[emailField.title] || "").trim()
      : "";

    if (emailField && !EMAIL_REGEX.test(enteredEmail)) {
      setcontent("Please enter a valid email address");
      setOpen(true);
      return;
    }

    // Manual validation for AntD Select
    const countryField = meeting.Fields.find(
      (f) => f.type?.toLowerCase() === "country",
    );
    if (countryField && !formData[countryField.title]) {
      setcontent("Please select your country");
      setOpen(true);
      return;
    }
    // Validate phone country code is selected
    const phoneField = meeting.Fields.find((f) => f.type === "phone");
    if (phoneField && !phoneCountryCode) {
      setcontent("Please select a country code for the phone number");
      setOpen(true);
      return;
    }
    if (phoneField) {
      const phoneValue = formData[phoneField.title] || "";
      const totalPhoneDigits = phoneValue.replace(/\D/g, "").length;
      if (totalPhoneDigits > MAX_PHONE_DIGITS) {
        setcontent("Country code + number must be 15 digits or less");
        setOpen(true);
        return;
      }
    }
    if (formData?.Phone?.length < 9) {
      setcontent("Please write the complete phone number");
      setOpen(true);
      return;
    }

    // Validate required checkboxes
    const requiredCheckbox = meeting.Fields.find(
      (f) =>
        f.type?.toLowerCase() === "checkbox" &&
        f?.require &&
        !formData[f.title],
    );
    if (requiredCheckbox) {
      setcontent(`Please check the required field: ${requiredCheckbox.title}`);
      setOpen(true);
      return;
    }

    const hide = message.loading("Action in progress", 0);

    if (
      meeting?.user?.find(
        (value) =>
          value?.Email?.trim()?.toLowerCase() === enteredEmail.toLowerCase(),
      )
    ) {
      console.log(enteredEmail);

      setcontent("This Email is Already Registerd");
      setOpen(true);
      setTimeout(() => {
        hide(); // Call hide to stop the loading message
      }, 2000);

      setregisterform(false);
    } else {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      const urlencoded = new URLSearchParams();
      urlencoded.append("user", JSON.stringify(formData));
      urlencoded.append("_id", meeting._id);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: urlencoded,
        redirect: "follow",
      };

      await fetch(
        `${process.env.REACT_APP_API_URL}/register-user-in-event`,
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          setmeeting(result);

          setcontent(
            "Thank you for registering! Please check your email for further details",
          );
          setOpen(true);
          setTimeout(() => {
            hide(); // Call hide to stop the loading message
          }, 2000);

          setregisterform(false);
        })
        .catch((error) => console.error(error));
    }
  };

  const checkuser = async (e) => {
    e.preventDefault();

    const user = meeting?.user?.find(
      (user) => user?.Email?.toLowerCase() === email?.toLowerCase(),
    );

    if (user) {
      if (meeting.Password?.toLowerCase() === password?.toLowerCase()) {
        console.log(user); // Log the found user
        setname(user.Name);
        setentermeeting(true); // Uncomment this line to allow entering the meeting
        onJoinRoom();
      } else {
        setcontent("Please Enter Correct Event Password");
        setOpen(true);
      }
    } else {
      // message.error("You have not registered yet. Please complete your registration to join the event");
      setcontent(
        "You have not registered yet. Please complete your registration to join the event",
      );
      setOpen(true);
    }
  };
  const Alertt = ({ Content }) => {
    return (
      <>
        <div className="alerttt">
          <div className="alertbg" onClick={() => setOpen(!open)}></div>
          <div className="alertcontant">
            {Content}

            <button
              onClick={() => setOpen(!open)}
              className="registerformdivbutton"
              style={{ padding: "10px 20px", width: "fit-content" }}
            >
              OK
            </button>
          </div>
        </div>
      </>
    );
  };
  const sendquestiontobackend = async (e) => {
    e.preventDefault();
    const hide = message.loading("Action in progress", 0);

    const timeanddate = new Date();

    const Question = {
      time: timeanddate,
      name: name,
      email: email,
      quetion: inputquestin,
    };

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    const urlencoded = new URLSearchParams();
    urlencoded.append("question", JSON.stringify(Question));
    urlencoded.append("_id", meeting._id);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    await fetch(
      `${process.env.REACT_APP_API_URL}/add-question-in-event`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        // Add the last question from the response to messages
        if (result.data && result.data.lastQuestion) {
          const questionToAdd = Array.isArray(result.data.lastQuestion)
            ? result.data.lastQuestion[0]
            : result.data.lastQuestion;
          setmessagesss((prevMessages) => [...prevMessages, questionToAdd]);
        }
        setinputquestin("");

        setTimeout(() => {
          hide(); // Call hide to stop the loading message
        }, 2000);

        setregisterform(false);
      })
      .catch((error) => console.error(error));
  };
  const handleSearch = (searchText) => {
    if (!searchText) {
      setOptions([]); // Clear options if no search text
      return;
    }

    // Filter countries that include the search text
    const filteredCountries = countries
      .filter((item) =>
        item.name.common?.toLowerCase().includes(searchText?.toLowerCase()),
      )
      .map((item) => ({
        value: item.name.common, // Use country name as value
        label: item.name.common, // Use country name as label
      }));

    setOptions(filteredCountries);
  };
  // if (!meeting || !meeting.Fields || !meeting.Schedule) {
  //     return (
  //       <MeetingSkeleton />
  //     );
  //   }
  return (
    <>
      {" "}
      {!meeting ? (
        <MeetingSkeleton />
      ) : (
        <div>
          {open && (
            <>
              <Alertt Content={content} />
            </>
          )}
          {entermeeting ? (
            <>
              {meeting.status ? (
                <>
                  <div className="aftermeeting">
                    <div className="sCsSbKP9yxvw4LQAeaTz zego_model_parent screen">
                      <div className="vadio">
                        <ReactPlayer
                          className="videoplayer"
                          url={meeting?.recording}
                          controls
                          width="100%"
                          height={"100%"}
                        />
                      </div>
                      <div style={{ display: "flex", gap: "20px" }}>
                        <div
                          className="vRymZYPLKPwd4n9uqA9E"
                          onClick={() => setentermeeting(false)}
                        ></div>
                        <div
                          className="aUBcrib1jsrHTK9vhlVZ "
                          onClick={() => setchatbox(!chatbox)}
                          style={{ width: "50px", height: "50px" }}
                        ></div>
                      </div>
                    </div>
                    {chatbox ? (
                      <>
                        <div
                          className="M4HRY2n7rpNAd1UjDNZe quetionnnwala quetionnnwala2"
                          style={{
                            margin: "20px 35px 20px 0",
                            overflow: "auto",
                            maxHeight: "90vh",
                            minWidth: "320px",
                          }}
                        >
                          <div className="n6GuqIk3cK3cSgL5gW1Z">
                            Any questions you want to ask?
                            <span
                              className="UYkwihM45bjIVQZSfpze"
                              onClick={() => setchatbox(!chatbox)}
                            ></span>
                          </div>
                          <div className="Z2PYS5vNVghY4m46zQQV">
                            <div className="ycoskpkASJJEiimQJINL">
                              <div className="z_Raef7MoQTTp7fHENMF">
                                {messagesss?.map((value) => (
                                  <>
                                    {value?.email === email && (
                                      <>
                                        <div class="yZqd3D1to9HjAdrmztDe">
                                          <div class="g6Dz8R9i4FALDRdhWQ7x">
                                            <span class="EwMm20qxkaVBq7882Tmx">
                                              {value?.name}
                                            </span>
                                            <span class="Xy7oIKiLKSjzCBwqt4OA">
                                              {value?.time}
                                            </span>
                                          </div>
                                          <p class="false false">
                                            {value?.quetion}
                                          </p>
                                        </div>
                                      </>
                                    )}
                                  </>
                                ))}
                              </div>
                              <form
                                onSubmit={sendquestiontobackend}
                                className="xM8CBkrn0wtFOdOP84Bb"
                              >
                                <textarea
                                  value={inputquestin}
                                  onChange={(e) =>
                                    setinputquestin(e.target.value)
                                  }
                                  required
                                  placeholder="Submit your question"
                                />
                                <button disabled=""></button>
                              </form>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </>
              ) : (
                <>
                  {/* <div style={{ width: "100%", height: "0", position: "relative" }}><iframe src={"https://streamyard.com/watch/B3XTJEtgbqJJ?embed=true"} width="100%" frameborder="0" allow="autoplay; fullscreen" style={{ width: "100%", height: "100vh", position: "absolute", left: "0px", top: 0, pxoverflow: "hidden" }}></iframe></div> */}
                  <div style={{ width: "100%", height: "100vh" }}>
                    <iframe
                      style={{ width: "100%", height: "100vh" }}
                      src={meeting.iframe}
                    ></iframe>
                  </div>
                </>
              )}
            </>
          ) : (
            <>
              <div className="maindiv" style={{ flexDirection: "column" }}>
                <div className="preview">
                  <div style={{ width: "100%" }}>
                    {" "}
                    <Image
                      src={meeting.coverphoto}
                      alt=""
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="preview22">
                    <div className="meetingdetails">
                      <div className="head">
                        <div class="date-card">
                          <div class="month">{date.month}</div>
                          <div class="day">{date.day}</div>
                          <div class="time">
                            {date.hours}:{date.minutes} {date.period}
                          </div>
                        </div>
                        <div>
                          <h2>{meeting.title}</h2>
                          <p style={{ color: "gray" }}>By GutMapDx</p>
                        </div>
                      </div>
                      <div>
                        <p style={{ marginLeft: "30px" }}>
                          <span
                            dangerouslySetInnerHTML={{ __html: meeting.About }}
                          />
                        </p>
                      </div>
                    </div>

                    <div className="meetingjoin">
                      <CountdownTimer timeRemaining={timeRemaining} />

                      <div>
                        {registerform ? (
                          <>
                            <form
                              className="registerform"
                              onSubmit={handleSubmit}
                            >
                              {meeting?.Fields?.map((field, index) => {
                                return (
                                  <div key={index}>
                                    {field.type.toLowerCase() === "select" ? (
                                      <>
                                        <label>{field.title}</label>
                                        <select
                                          value={formData[field.title] || ""}
                                          onChange={(e) =>
                                            handleChange(
                                              field.title,
                                              e.target.value,
                                            )
                                          }
                                          required={field.require}
                                        >
                                          <option disabled value="">
                                            Please Select a Value
                                          </option>
                                          {field.option.map((option, idx) => (
                                            <option
                                              key={idx}
                                              value={option.placeholder}
                                            >
                                              {/* //value removed */}
                                              {option.placeholder}
                                            </option>
                                          ))}
                                        </select>
                                      </>
                                    ) : field.type?.toLowerCase() ===
                                      "checkbox" ? (
                                      <>
                                        <div className="consent-checkbox">
                                          <label className="custom-checkbox">
                                            <input
                                              type="checkbox"
                                              checked={
                                                formData[field.title] || false
                                              }
                                              onChange={(e) =>
                                                handleChange(
                                                  field.title,
                                                  e.target.checked,
                                                )
                                              }
                                            />
                                            <span className="checkmark"></span>
                                            <span className="consent-label-text">
                                              {field.title}
                                            </span>
                                          </label>
                                        </div>{" "}
                                      </>
                                    ) : field.type.toLowerCase() ===
                                      "country" ? (
                                      <>
                                        <label>{field.title}</label>

                                        <Select
                                          value={
                                            formData[field.title] || undefined
                                          }
                                          onChange={(value) =>
                                            handleChange(field.title, value)
                                          }
                                          placeholder="Select Country"
                                          showSearch
                                          required
                                          className="autocompleee"
                                          optionFilterProp="children"
                                          filterOption={(input, option) =>
                                            option.children
                                              ?.toLowerCase()
                                              .includes(input?.toLowerCase())
                                          }
                                        >
                                          {countries.map((c) => (
                                            <Select.Option
                                              key={c.name.common}
                                              value={c.name.common}
                                            >
                                              {c.name.common}
                                            </Select.Option>
                                          ))}
                                        </Select>
                                      </>
                                    ) : field.type.toLowerCase() === "phone" ? (
                                      <>
                                        <label>{field.title}</label>
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "10px",
                                            width: "100%",
                                          }}
                                        >
                                          <Select
                                            value={
                                              phoneCountryCode || undefined
                                            }
                                            onChange={(value) => {
                                              setPhoneCountryCode(value);
                                              const codeDigits = value.replace(
                                                /\D/g,
                                                "",
                                              );
                                              const current =
                                                formData[field.title] || "";
                                              const currentDigits =
                                                current.replace(/\D/g, "");
                                              let numbers = currentDigits;
                                              const prevCodeDigits =
                                                phoneCountryCode
                                                  ? phoneCountryCode.replace(
                                                      /\D/g,
                                                      "",
                                                    )
                                                  : "";

                                              if (
                                                prevCodeDigits &&
                                                numbers.startsWith(
                                                  prevCodeDigits,
                                                )
                                              ) {
                                                numbers = numbers.slice(
                                                  prevCodeDigits.length,
                                                );
                                              }

                                              if (
                                                numbers.startsWith(codeDigits)
                                              ) {
                                                numbers = numbers.slice(
                                                  codeDigits.length,
                                                );
                                              }

                                              const maxLocalDigits = Math.max(
                                                MAX_PHONE_DIGITS -
                                                  codeDigits.length,
                                                0,
                                              );
                                              numbers = numbers.slice(
                                                0,
                                                maxLocalDigits,
                                              );

                                              numbers = numbers.replace(
                                                /^0+/,
                                                "",
                                              );

                                              const nextValue = numbers.length
                                                ? `${value} ${numbers}`
                                                : `${value} `;

                                              handleChange(
                                                field.title,
                                                nextValue,
                                              );
                                            }}
                                            placeholder="Code"
                                            showSearch
                                            style={{
                                              width: "110px",
                                              minWidth: "110px",
                                              flexShrink: 0,
                                            }}
                                            filterOption={(input, option) => {
                                              const searchText =
                                                `${option.value} ${option.label}`?.toLowerCase();
                                              return searchText.includes(
                                                input?.toLowerCase(),
                                              );
                                            }}
                                          >
                                            {phoneCountries.map((c) => (
                                              <Select.Option
                                                key={c.name}
                                                value={c.code}
                                                label={c.name}
                                              >
                                                {c.code} {c.name}
                                              </Select.Option>
                                            ))}
                                          </Select>
                                          <input
                                            type="tel"
                                            value={formData[field.title] || ""}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              const cleanedValue =
                                                value.replace(/[^0-9\s]/g, "");

                                              if (!phoneCountryCode) {
                                                handleChange(
                                                  field.title,
                                                  cleanedValue,
                                                );
                                                return;
                                              }

                                              const codeDigits =
                                                phoneCountryCode.replace(
                                                  /\D/g,
                                                  "",
                                                );
                                              let numbers =
                                                cleanedValue.replace(
                                                  /\s+/g,
                                                  "",
                                                );

                                              if (
                                                numbers.startsWith(codeDigits)
                                              ) {
                                                numbers = numbers.slice(
                                                  codeDigits.length,
                                                );
                                              }

                                              const maxLocalDigits = Math.max(
                                                MAX_PHONE_DIGITS -
                                                  codeDigits.length,
                                                0,
                                              );
                                              numbers = numbers.slice(
                                                0,
                                                maxLocalDigits,
                                              );

                                              const nextValue = numbers.length
                                                ? `${phoneCountryCode} ${numbers}`
                                                : `${phoneCountryCode} `;

                                              handleChange(
                                                field.title,
                                                nextValue,
                                              );
                                            }}
                                            placeholder={
                                              phoneCountryCode
                                                ? `${phoneCountryCode} Enter number`
                                                : "Select country code first"
                                            }
                                            required={field.require}
                                            style={{
                                              flex: 1,
                                              minWidth: 0,
                                              boxSizing: "border-box",
                                            }}
                                          />
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <label>{field.title}</label>
                                        <input
                                          type={field.type}
                                          value={formData[field.title] || ""}
                                          onChange={(e) =>
                                            handleChange(
                                              field.title,
                                              e.target.value,
                                            )
                                          }
                                          required={field.require}
                                        />
                                      </>
                                    )}
                                  </div>
                                );
                              })}

                              <div>
                                <button>Register</button>
                              </div>

                              <div>
                                Registered Already?{" "}
                                <a
                                  href=""
                                  onClick={(e) => {
                                    setregisterform(false);
                                    e.preventDefault();
                                  }}
                                >
                                  Join Now
                                </a>
                              </div>
                            </form>
                          </>
                        ) : (
                          <>
                            <form className="registerform" onSubmit={checkuser}>
                              <div>
                                <label>Email</label>
                                <input
                                  type="email"
                                  required
                                  onChange={(e) => setemail(e.target.value)}
                                  value={email}
                                />
                              </div>

                              <div>
                                <label>Event Password</label>
                                <input
                                  type="password"
                                  required
                                  onChange={(e) => setpassword(e.target.value)}
                                  value={password}
                                />
                              </div>

                              <div>
                                <button>Join Event</button>
                              </div>

                              <div>
                                <div>
                                  Haven't Registered Yet?{" "}
                                  <a
                                    href=""
                                    onClick={(e) => {
                                      setregisterform(true);
                                      e.preventDefault();
                                    }}
                                  >
                                    Register Now
                                  </a>
                                </div>
                              </div>
                            </form>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
}

export default Meeting;
